<template>
  <div class="am-finance-company-selection-modal">
    <div class="am-finance-company-selection-header">
      <span>Alert</span>
    </div>
    <div class="am-finance-company-selection-body">
      <div class="am-finance-company-selection-main-table">
        <table>
          <tr>
            <td>
              Premium Finance Company:
            </td>
            <td>
              <select class="am-finance-company-selection-dropdown" v-model="quoteAttributes.selectedCompany">
                <option value="0">- Select a Premium Finance Company -</option>
                <option v-for="company in financeCompanies" :value="company.company.id">{{ company.company.name }}</option>
              </select>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="am-finance-company-selection-footer">
      <button type="button" class="btn btn-secondary btn-xs" @click="closeModal()">Cancel</button>
      <button type="button" class="btn btn-primary btn-xs" @click="openQuote()">OK</button>
    </div>
  </div>
</template>

<script>
  import api from './../http'
  export default {
    name: "FinanceCompanySelection",
    props: {
      productId:{
        type: Number,
        default: 0
      },
      insuranceType:{
        type: String,
        default: ''
      },
      quoteId:{
        type: Number,
        default: 0
      },
      transactionType:{
        type: String,
        default: ''
      },
      selectedCompany:{
        type: Number,
        default: 0
      },
      policyMinDate:{
        type: String,
        default: ''
      }
    },
    methods: {
      closeModal () {
        this.$store.dispatch('events/fireEvent', { name: 'finance-company-selection-close', data: null })
      },
      openQuote () {
        this.$store.dispatch('events/fireEvent', { name: 'finance-company-selection-submit', data: this.quoteAttributes })
      }
    },
    data () {
      return {
        quoteAttributes:{
          productId: 0,
          insuranceType: '',
          quoteId: 0,
          transactionType: '',
          selectedCompany: 0,
          policyMinDate: ''
        },
        financeCompanies: []
      }
    },
    mounted () {
      this.quoteAttributes.productId = this.productId
      this.quoteAttributes.insuranceType = this.insuranceType
      this.quoteAttributes.quoteId = this.quoteId
      this.quoteAttributes.transactionType = this.transactionType
      this.quoteAttributes.selectedCompany = this.selectedCompany
      this.quoteAttributes.policyMinDate = this.policyMinDate
    },
    asyncComputed: {
      financeCompanies: {
        get() {
          return api.makeRequest('/customer/finance/product/' + this.productId).then(
            (data) => {
              return data.data.productFinanceCompanies
            }
          )
        }
      }
    },
  }
</script>

<style scoped>
  .am-finance-company-selection-modal {
    background-color: whitesmoke;
  }
  .am-finance-company-selection-header {
    height: 35px;
    background-color: #428bca;
    padding: 10px;
    top: 0;
    color: white;
    font-weight: 700;
  }

  .am-finance-company-selection-footer {
    height: 50px;
    width:100%;
    position:relative;
    bottom: 0;
    padding: 15px;
    border-top: 1px solid #428bca;
  }

  .am-finance-company-selection-footer button {
    margin-left: 5px;
    float: right;
  }

  .am-finance-company-selection-main-table{
    padding: 10px;
    text-align: center;
  }

  .am-finance-company-selection-dropdown{
    text-align: center;
    margin-left: 20px;
  }

</style>
